import { faLock } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FC } from 'react'
import { Link } from 'react-router-dom'

import { DropdownMenuItem } from 'components/DropdownMenu'

export const GoToAdmin: FC = () => (
  <Link to="/admin">
    <DropdownMenuItem className="h-10">
      <FontAwesomeIcon icon={faLock} className="mr-2 w-4" />
      <span>Admin</span>
    </DropdownMenuItem>
  </Link>
)
